<script lang="ts">
  import { Accordion as AccordionPrimitive } from 'bits-ui-v2'
  import { cn } from '$lib/cn'

  let {
    ref = $bindable(null),
    class: className,
    level = 3,
    children,
    ...restProps
  }: Omit<AccordionPrimitive.TriggerProps, 'child'> & {
    level?: AccordionPrimitive.HeaderProps['level']
  } = $props()
</script>

<AccordionPrimitive.Header {level} class="flex">
  <AccordionPrimitive.Trigger
    bind:ref
    data-slot="accordion-trigger"
    class={cn(
      'group/accordion-trigger flex w-full items-center justify-between transition-colors duration-150',
      className,
    )}
    {...restProps}
  >
    {@render children?.()}
  </AccordionPrimitive.Trigger>
</AccordionPrimitive.Header>
